import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-form" }

import { ref, reactive, onMounted } from 'vue';
import { bindPhone, sendCode, getUserInfo } from "@/api/common.js"
import { ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'phoneDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    phone: '',
    code: ''
})
const codeTime = ref(0)
let codeTimer = null
const emitList = __emit
const formRules = {
    phone: [
        {
            message: '请输入手机号',
            required: true
        }
    ],
    code: [
        {
            message: '请输入验证码',
            required: true
        }
    ]
}

function bindPhoneEvent() {
    loginRef.value.validate(valid => {
        if (valid) {
            bindPhone(formData.value).then(res => {
                console.log(res)
                ElMessage.success('绑定成功')
                emitList('close')
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function getCode() {
    if (codeTime.value > 0) {
        return ElMessage.warning('倒计时结束后再发送')
    } else {
        loginRef.value.validateField(['phone'], valid => {
            if (valid) {
                const params = {
                    phone: formData.value.phone,
                    type: '05'
                }
                console.log(params)
                sendCode(params).then(res => {
                    ElMessage.success('验证码已发送')
                    codeTime.value = 60
                    codeTimer = setInterval(() => {
                        if (!codeTime.value) {
                            clearInterval(codeTimer)
                            codeTimer = null
                        } else {
                            codeTime.value--;
                        }
                    }, 1000)
                }).catch(err => {
                    console.log(err)
                })
            }
        })
    }
}

function closeEvent() {
    emitList('close')
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogShow).value = $event)),
    width: "400px",
    title: "请绑定手机号",
    center: "",
    onClose: closeEvent,
    "close-on-click-modal": false,
    "modal-class": "dialog-new-model"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "login-title" }, "您的账号尚未绑定家长手机号", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref_key: "loginRef",
            ref: loginRef,
            model: formData.value,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "phone" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.phone,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.phone) = $event)),
                            placeholder: "请输入手机号"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.code,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.code) = $event)),
                            placeholder: "请输入验证码"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        color: "#ef8b25",
                        plain: "",
                        onClick: getCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(codeTime.value?`${codeTime.value}秒重新获取`:'获取验证码'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"width":"100%"},
            color: "#ef8b25",
            class: "footer-btn1",
            onClick: bindPhoneEvent
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("确认绑定")
            ])),
            _: 1,
            __: [3]
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})